"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMultiCurrencyOptions = exports.getCompanyCurrencyOptions = exports.getNonCompanyCurrencies = exports.getActiveMultiCurrency = exports.getMultiCurrencies = exports.getCompanyCurrency = exports.getFetchMultiCurrencyCodesRequestStatus = exports.getFetchMultiCurrencyActiveRequestStatus = exports.getFetchMultiCurrenciesRequestStatus = exports.getFetchCompanyCurrencyRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _reselect = require("reselect");

var _actions = require("settings-ui-sdk/MultiCurrency/actions");

var getMultiCurrencyState = function getMultiCurrencyState(state) {
  return state.multiCurrency;
};

var getFetchCompanyCurrencyRequestStatus = (0, _getRequestStatus.default)(_actions.MultiCurrencyActionTypes.FETCH_HOME_CURRENCY);
exports.getFetchCompanyCurrencyRequestStatus = getFetchCompanyCurrencyRequestStatus;
var getFetchMultiCurrenciesRequestStatus = (0, _getRequestStatus.default)(_actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCIES);
exports.getFetchMultiCurrenciesRequestStatus = getFetchMultiCurrenciesRequestStatus;
var getFetchMultiCurrencyActiveRequestStatus = (0, _getRequestStatus.default)(_actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_ACTIVE);
exports.getFetchMultiCurrencyActiveRequestStatus = getFetchMultiCurrencyActiveRequestStatus;
var getFetchMultiCurrencyCodesRequestStatus = (0, _getRequestStatus.default)(_actions.MultiCurrencyActionTypes.FETCH_MULTI_CURRENCY_CODES);
exports.getFetchMultiCurrencyCodesRequestStatus = getFetchMultiCurrencyCodesRequestStatus;
var getCompanyCurrency = (0, _reselect.createSelector)([getMultiCurrencyState], function (state) {
  return state.get('companyCurrency');
});
exports.getCompanyCurrency = getCompanyCurrency;
var getMultiCurrencies = (0, _reselect.createSelector)([getMultiCurrencyState], function (state) {
  return state.get('currencies').toList().filter(function (currency) {
    return currency.visible === true;
  });
});
exports.getMultiCurrencies = getMultiCurrencies;
var getActiveMultiCurrency = (0, _reselect.createSelector)([getMultiCurrencyState], function (state) {
  return state.get('activeMultiCurrency');
});
exports.getActiveMultiCurrency = getActiveMultiCurrency;
var getNonCompanyCurrencies = (0, _reselect.createSelector)([getMultiCurrencyState, getCompanyCurrency], function (state, companyCurrency) {
  return state.get('currencies').toList().filter(function (currency) {
    return currency.fromCurrencyCode !== companyCurrency && currency.visible === true;
  });
});
exports.getNonCompanyCurrencies = getNonCompanyCurrencies;
var getCompanyCurrencyOptions = (0, _reselect.createSelector)([getMultiCurrencyState, getCompanyCurrency], function (state) {
  return state.get('currencies').filter(function (currency) {
    return currency.visible === true;
  });
});
exports.getCompanyCurrencyOptions = getCompanyCurrencyOptions;
var getMultiCurrencyOptions = (0, _reselect.createSelector)([getMultiCurrencyState, getCompanyCurrency], function (state, companyCurrency) {
  return state.get('currencyCodes').filter(function (currency) {
    return currency !== companyCurrency;
  });
});
exports.getMultiCurrencyOptions = getMultiCurrencyOptions;